.wrap {
  position: relative;
  border: 1px solid var(--border-primary);
  background: var(--bg-primary);
}

.svg {
  display: block;
  width: 100%;
  height: 560px;
  touch-action: none;
  cursor: grab;
  background-image: radial-gradient(var(--border-subtle) 1px, transparent 1px);
  background-size: 22px 22px;
}

.svg:active {
  cursor: grabbing;
}

.node {
  cursor: move;
}

.box {
  fill: var(--bg-elevated);
  stroke: var(--border-primary);
  stroke-width: 1;
}

.selected .box {
  stroke: var(--accent);
  stroke-width: 2;
}

.title {
  fill: var(--text-primary);
  font: 600 13px var(--font-sans);
  pointer-events: none;
}

.badge {
  fill: var(--accent-text);
  font: 600 10px var(--font-sans);
  letter-spacing: 0.08em;
  pointer-events: none;
}

.id {
  fill: var(--text-muted);
  font: 11px var(--font-mono);
  pointer-events: none;
}

.port {
  fill: var(--text-secondary);
  font: 12px var(--font-sans);
  pointer-events: none;
}

.dot {
  fill: var(--bg-primary);
  stroke: var(--text-secondary);
  stroke-width: 2;
  cursor: crosshair;
}

.dot:hover {
  stroke: var(--accent);
}

.linked {
  fill: var(--accent);
  stroke: var(--accent);
}

.inlet {
  fill: var(--text-muted);
  pointer-events: none;
}

.edge {
  fill: none;
  stroke: var(--text-muted);
  stroke-width: 1.75;
  pointer-events: none;
}

.draft {
  stroke: var(--accent);
  stroke-dasharray: 5 4;
}

.arrow {
  fill: var(--text-muted);
}

.zoom {
  position: absolute;
  right: 12px;
  bottom: 12px;
  display: flex;
  flex-direction: column;
  border: 1px solid var(--border-primary);
  background: var(--bg-elevated);
}

.zoom button {
  width: 36px;
  height: 36px;
  font: inherit;
  font-size: 1.125rem;
  color: var(--text-primary);
  background: transparent;
  border: 0;
  border-bottom: 1px solid var(--border-subtle);
  cursor: pointer;
}

.zoom button:last-child {
  border-bottom: 0;
}

.zoom button:hover {
  background: var(--bg-secondary);
}

.hit {
  fill: none;
  stroke: transparent;
  stroke-width: 22;
  pointer-events: stroke;
  cursor: context-menu;
}

.hot {
  stroke: var(--accent);
  stroke-width: 2.5;
}
